import {useAuth0} from '@auth0/auth0-react';
import React, {useEffect} from 'react';
import PropTypes from 'prop-types';

import Auth0Loading from './Auth0Loading';
import ErrorUtils from 'utils/error-utils';
import AuthenticationAPI from 'api/authentication';
import useConfig from 'hooks/use-config';
import {redirect} from 'utils/window';
import useAuth0APISetup from './useAuth0APISetup';

const Auth0Callback = ({history}) => {
    const {isAuthenticated, isLoading} = useAuth0();
    const {isReady} = useAuth0APISetup();
    const {siteUrl} = useConfig();

    useEffect(() => {
        if (isLoading) {
            return;
        }

        if (!isAuthenticated) {
            redirect(`${siteUrl}/login${history.location.search || ''}`);

            return;
        }

        if (isReady) {
            const redirectUser = async () => {
                await AuthenticationAPI.setCookie();

                // eslint-disable-next-line node/prefer-global/url-search-params
                const urlParams = new URLSearchParams(history?.location.search);
                const nextUrl = urlParams.get('next');

                if (nextUrl) {
                    history?.push(nextUrl);

                    return;
                }

                redirect(`${siteUrl}/account-settings/`);
            };

            redirectUser().catch(error => {
                ErrorUtils.sendSentryError(error);

                history?.push('/auth/error/');
            });
        }
    }, [isAuthenticated, isLoading, isReady, history, siteUrl]);

    return <Auth0Loading />;
};

Auth0Callback.propTypes = {
    history: PropTypes.object,
};

export default Auth0Callback;
